import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/createStore';
import './index.scss';
import App from './App';
import 'react-toastify/dist/ReactToastify.min.css';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { httpClientIntegration } from '@sentry/integrations';

if (!!process.env.REACT_APP_SENTRY_DSN)
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing(),
      new httpClientIntegration({
        failedRequestStatusCodes: [400],
        tracing: true,
        breadcrumbCategories: ['xhr', 'fetch'],
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_RATE) || 1.0,
  });

const sentryOnError = (error) => {
  console.error(
    `An error has occurred in dashboard.\nError: ${error.toString()}\n`
  );
};

ReactDOM.render(
  <Sentry.ErrorBoundary onError={sentryOnError}>
    <React.StrictMode>
      <Provider store={store}>
        <Router basename='/dashboard'>
          <App />
        </Router>
      </Provider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);
